import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button } from '@blueprint/ui';
import { AgentImageWrapper } from '../FeaturedProperties.styles';

const CTAWrapper = styled(AgentImageWrapper)(
    (props) => css`
        border-top: 0;
        margin: 0 ${props.theme.spacing['16px']};

        ${Button} {
            margin: 0;
        }
    `
);

export { CTAWrapper };
